<div class="bg-white rounded-2xl shadow-sm border border-slate-500 flex flex-col overflow-hidden">
  <div class="px-8 py-3 border-b border-slate-300 flex items-center justify-between bg-white">
    <h2 class="text-[18px] font-bold text-slate-800">
      {{ title() }} ({{ totalItems() }})
    </h2>
  </div>

  <div class="flex-1 overflow-x-auto">
      @if (totalItems() > 0) {
    <table class="w-full table-fixed text-sm">
      <thead>
        <tr
          class="bg-slate-100/80 text-left text-[12px] font-black text-slate-950 tracking-[0.1em] border-b border-slate-300">

          @for (col of columns(); track col.key) {

          <th
            scope="col"
            class="px-6 py-2 font-bold text-[11px]"
            [style.width]="col.width || ''"
            [class.px-6]="$first || ($last && !showDelete())"
            [class.text-center]="col.align === 'center'"
            [class.text-right]="col.align === 'right'">

            @if (col.sortable) {

            <button
              (click)="sortBy(col.key)"
              class="inline-flex items-center gap-1 hover:text-primary transition-colors focus:outline-none">

              {{ col.label }}

              <span class="flex flex-col leading-none">
                <svg
                  class="w-3 h-3"
                  [class.text-primary]="sortColumn() === col.key && sortDirection() === 'asc'"
                  [class.text-slate-400]="!(sortColumn() === col.key && sortDirection() === 'asc')"
                  viewBox="0 0 10 6"
                  fill="currentColor">
                  <path d="M5 0L10 6H0L5 0Z" />
                </svg>

                <svg
                  class="w-3 h-3"
                  [class.text-primary]="sortColumn() === col.key && sortDirection() === 'desc'"
                  [class.text-slate-400]="!(sortColumn() === col.key && sortDirection() === 'desc')"
                  viewBox="0 0 10 6"
                  fill="currentColor">
                  <path d="M5 6L0 0H10L5 6Z" />
                </svg>
              </span>

            </button>

            } @else {

            {{ col.label }}

            }

          </th>
          }
          @if (showDelete()) {
          <th class="px-6 py-2 text-right font-bold text-[11px]" style="width:10%">
            Delete
          </th>
          }
        </tr>
      </thead>
      <tbody>

        @for (item of sortedData(); track $index) {

        <tr
          (click)="rowClick.emit(item)"
          class="cursor-pointer border-b last:border-b-0 transition-all group"
          [ngClass]="[
            (title() === 'User List' || title() === 'Report List' || title() === 'Role List')
              ? 'border-gray-300 hover:bg-blue-100'
              : 'border-slate-300 hover:bg-slate-50/50',

            isSelected(item)
              ? ((title() === 'User List' || title() === 'Report List' || title() === 'Role List')
                ? 'bg-blue-100 border-l-4 border-l-primary'
                : 'bg-primary/5 border-l-4 border-l-primary')
              : ''
          ]">

          @for (col of columns(); track col.key) {

          <td
            class="py-2"
            [class.px-6]="$first || ($last && !showDelete())"
            [class.text-center]="col.align === 'center'"
            [class.text-right]="col.align === 'right'">
            @if (cellTemplate) {

            <ng-container
              [ngTemplateOutlet]="cellTemplate"
              [ngTemplateOutletContext]="{
                $implicit: item,
                column: col.key
              }">
            </ng-container>

            } @else {

            <span
              class="block w-full truncate whitespace-nowrap text-[12px] font-medium text-slate-600"
              [attr.title]="getCellValue(item, col.key)">
              {{ getCellValue(item, col.key) }}
            </span>

            }
          </td>
          }
          @if (showDelete()) {

          <td class="px-6 py-2">

            <div class="flex justify-end">

              <button
                (click)="onDelete(item, $event)"
                class="p-2 text-slate-900 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-rose-500 outline-none"
                aria-label="Delete">

                <svg
                  class="w-[18px] h-[18px]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">

                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  }@else {
  
  <div class="flex items-center justify-center py-16">
    <p class="text-sm font-medium text-slate-500">
      No data found.
    </p>
  </div>
  
  }
  </div>
@if (totalItems() > 1) {
  <app-pagination
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    [totalItems]="totalItems()"
    [pageSize]="pageSize()"
    [itemLabel]="itemLabel()"
    (pageChange)="pageChange.emit($event)">
  </app-pagination>
}
</div>